import { createContext, Dispatch, SetStateAction } from "react";
import { AppendixFile } from "../sdkStructs";

export interface AppendixStates {
  appendix: AppendixFile[];
  setAppendix: Dispatch<SetStateAction<AppendixFile[]>>;
}

export const AppendixContext = createContext<AppendixStates>({
  appendix: [],
  setAppendix: () => {},
});